import { z } from 'zod';

import { einSchema, timestampSchema, uuidSchema } from '../general';
import { addressSchema, bigIntSchema } from '../web3';

import { entityTypeWithSubprojectSchema } from './misc';
import { evmTokenSchema } from './tokens';

const donationRecipientOrgSchema = z.object({
  type: z.literal('org'),
  einOrId: z.union([einSchema, uuidSchema]),
  subprojectId: uuidSchema.optional(),
});
export type DonationRecipientOrg = z.infer<typeof donationRecipientOrgSchema>;
const donationRecipientFundSchema = z.object({
  type: z.literal('fund'),
  id: uuidSchema,
});
export type DonationRecipientFund = z.infer<typeof donationRecipientFundSchema>;
export const donationRecipientSchema = z.union([donationRecipientOrgSchema, donationRecipientFundSchema]);
export type DonationRecipient = z.infer<typeof donationRecipientSchema>;

export const donationSchema = z.object({
  id: uuidSchema,
  chainId: z.number(),
  entityType: entityTypeWithSubprojectSchema,
  destinationEntity: uuidSchema,
  transactionHash: addressSchema,
  destinationContractAddress: addressSchema,
  donorUserId: uuidSchema.nullish(),
  donorAddress: addressSchema,
  /** A Currency unit value */
  inputAmount: bigIntSchema,
  // TODO: Split into union types for inputToken and inputStock
  inputToken: evmTokenSchema.nullish(),
  /** A USDC value */
  netOutputBaseToken: bigIntSchema,
  /** A USDC value */
  fee: bigIntSchema,
  outputBaseToken: evmTokenSchema,
  createdAtUtc: timestampSchema,
});
export type Donation = z.infer<typeof donationSchema>;
export const isDonation = (obj: unknown): obj is Donation => donationSchema.safeParse(obj).success;
